
export enum HabilitationStatusName {   
    REFUSE="REFUSE",
    NON_DEMANDE="NON_DEMANDE",
    DEMANDE="DEMANDE",
    ACCEPTE="ACCEPTE"
}